<mat-form-field appearance="outline" fxFlex="100">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    autocomplete="none"
    [formControl]="control"
    placeholder="DD/MM/YYYY"
    [required]="required!"
    [matDatepicker]="picker"
    (dateChange)="onInputBlur()"
    (blur)="onInputBlur()"
    (keyup)="autoDateFormat($event)"
    [min]="minDate"
    hidden
    #valueModel
  />
  <mat-datepicker-toggle
    *ngIf="!disabled"
    matSuffix
    [for]="picker"
    [matTooltip]="getDateErrorTooltip()"
    [ngClass]="{ 'error-icon': hasDateError() }"
  ></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
